import * as React from 'react';
export function IconTriangle() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "8",
    viewBox: "0 0 404.308 404.309"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 101.08h404.308L202.151 303.229 0 101.08z"
  }));
}